export const formatFeatureLabel = (value?: string | null) => {
  const text = String(value ?? "").trim();
  if (!text) return "N/A";

  return text
    .replaceAll(/[_-]+/g, " ")
    .replaceAll(/\s+/g, " ")
    .replaceAll(/\b\w/g, (char) => char.toUpperCase());
};
